import ReactNativeInstall from "../../../../contents/docs/integrate/_snippets/install-react-native.mdx";
import * as React from 'react';
export default {
  ReactNativeInstall,
  React
};